import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="notes-footer">
      <div className="notes-footer__inner">
        <div className="notes-footer__brand">
          <span className="notes-footer__brand-main">MySimpleDB</span>
          <span className="notes-footer__brand-notes">Notes</span>
        </div>

        <nav className="notes-footer__links" aria-label="Footer navigation">
          <Link to="/help">Help &amp; Support</Link>
          <Link to="/contact">Contact Us</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/about">About</Link>
        </nav>

        <div className="notes-footer__copyright">
          © {new Date().getFullYear()} MySimpleDB Notes. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
